import CryptoJS, { CipherOption } from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';

export const CryptoHelper = {
    encrypt(message: string, key: string, option?: CipherOption) {
        return CryptoJS.AES.encrypt(message, key, option).toString();
    },

    decrypt(message: string, key: string, option?: CipherOption) {
        return CryptoJS.AES.decrypt(message, key, option).toString(
            CryptoJS.enc.Utf8,
        );
    },

    decryptByPrivateKey(message: string, privateKey: string): string | false {
        const crypt = new JSEncrypt();
        crypt.setKey(privateKey);
        return crypt.decrypt(message);
    },
};
